
import createIcon from "./createIcon";

export const AIQAIcon = createIcon('AIQA', (props) => {
  return (
    <svg {...props}>
      <rect width="16.000000" height="16.000000" fill="#FFFFFF" fillOpacity="0" />
      <rect x="7.080078" y="2.000000" rx="0.700000" width="1.400000" height="13.000000" transform="rotate(23.0026 7.080078 2.000000)" fill={props.color} fillOpacity="1.000000" />
      <rect rx="0.700000" width="1.400000" height="13.000000" transform="matrix(-0.920487 0.390773 0.390773 0.920487 7.82031 2)" fill={props.color} fillOpacity="1.000000" />
      <rect x="11.283203" y="5.173828" rx="0.700000" width="1.400000" height="9.122070" fill={props.color} fillOpacity="1.000000" />
      <rect x="11.283203" y="2.166016" rx="0.700000" width="1.400000" height="1.945312" fill={props.color} fillOpacity="1.000000" />
    </svg >
  )
});
